import { render, staticRenderFns } from "./BaseSidebar.vue?vue&type=template&id=5204e756&"
import script from "./BaseSidebar.vue?vue&type=script&lang=js&"
export * from "./BaseSidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports